import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CommonState, ProductLink, ProductLinkAction, ProductLinkSelector } from "@obg/ngx.common";
import { CoreState } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { filter, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-product-links-container",
	templateUrl: "./product-links.container.html",
	styleUrls: ["./product-links.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ProductLinksContainer implements OnInit {
	@HostBinding("class.obg-m-product-links") hostCssClass = true;

	@HostBinding("class.obg-m-product-links-3") host3LinksCssClass = false;

	@HostBinding("class.obg-m-product-links-2") host2LinksCssClass = false;

	productLinks$ = this.store.pipe(
		select(this.productLinkSelector.get()),
		filter((links) => !!links),
		tap((links) => {
			this.host2LinksCssClass = links.length <= 2;
			this.host3LinksCssClass = links.length <= 3;
		})
	);

	placeholders = Array(5);

	constructor(
		private store: Store<CoreState & CoreContentState & CommonState>,
		private productLinkAction: ProductLinkAction,
		private productLinkSelector: ProductLinkSelector
	) {}

	ngOnInit() {
		this.store.dispatch(this.productLinkAction.get());
	}

	trackByLink(_index: number, link: ProductLink) {
		return link.key;
	}
}
